module.exports = __webpack_public_path__ + "6940da02bacb2fb2a7c75d6f2cbe0ba3.png";